(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elogbooksSelectSiteMultipleHtmlOptions', function ($uibModal, apiClient, lodash, $q) {
            return {
                restrict: 'A',
                templateUrl: '/modules/directives/form-elements/select-site-multiple-html-options/select-site-multiple-html-options.html',
                scope: {
                    model: '=ngModel',
                    hideTitle: '@?',
                    hideAdvanced: '@?'
                },
                require: ['ngModel', 'elogbooksSelectMultipleHtmlOptions'],
                controller: ['$scope', function($scope) {
                    var defaultModel = {
                        link : null,
                        response: null,
                        loading : false,
                        responseKeyPath: 'data',
                        itemHrefPath: '_links.self.href',
                        itemValuePath: 'name',
                        keyword: null,
                        expandedSearch: false,
                        required : false,
                        disabled : false,
                        selectedItems: [],             // Right-hand list items [{href, value, id}]
                        items: [],                     // Left-hand list items (not selected)
                        map : map,
                        getResponseData : getResponseData,
                        filterResponse : filterResponse,
                        clear : clearAction,
                        expandSearch : expandSearchAction
                    };

                    var canceller = $q.defer();
                    var selectedCanceller = $q.defer();

                    $scope.add = addAction;
                    $scope.remove = removeAction;

                    // Merge with defaults
                    $scope.model = lodash.merge(defaultModel, $scope.model || {});

                    // Left and right list models for the html-options component
                    $scope.allSitesModel = {
                        invalid: false,
                        isLoading: !!$scope.model.loading,
                        selected: [],
                        options: [],
                        hasMoreOptions: false,
                        loadNext: null
                    };

                    $scope.selectedSitesModel = {
                        invalid: false,
                        isLoading: false,
                        selected: [],
                        options: [],
                        hasMoreOptions: false,
                        loadNext: null
                    };

                    $scope.selectedSitesFilteringKeyword = '';

                    // Prefill data
                    if ($scope.model.response) {
                        // Keep the full response to enable loadNext
                        $scope.model.response = $scope.model.response;
                        $scope.allSitesModel.options = lodash.differenceBy(
                            $scope.model.filterResponse($scope.model.response),
                            $scope.model.selectedItems,
                            'href'
                        );

                        setupLoadMore($scope.model.response);
                    }

                    // Initialize selected sites list
                    $scope.selectedSitesModel.options = angular.copy($scope.model.selectedItems || []);
                    setupSelectedLoadMore($scope.model.selectedResponse);

                    // Watch for changes in selected filter to update visible selected options
                    $scope.$watch('selectedSitesFilteringKeyword', lodash.debounce(function(keyword){
                        applySelectedFilter(keyword || '');
                    }, 200));

                    // Debounced search on the left list (all sites)
                    $scope.$watch('model.keyword', lodash.debounce(searchAction, 500));

                    function applySelectedFilter(keyword) {
                        const items = angular.copy($scope.model.selectedItems || []);

                        if (!keyword) {
                            $scope.selectedSitesModel.isLoading = false;
                            $scope.selectedSitesModel.options = items;
                            setupSelectedLoadMore($scope.model.selectedResponse);
                            return;
                        }

                        const lower = ('' + keyword).toLowerCase();
                        $scope.selectedSitesModel.isLoading = false;
                        $scope.selectedSitesModel.options = items.filter(function(item){
                            return item && item.value && ('' + item.value).toLowerCase().indexOf(lower) !== -1;
                        });
                    }

                    function removeAction () {
                        if (!$scope.selectedSitesModel.selected || !$scope.selectedSitesModel.selected.length) {
                            return;
                        }

                        // Move selected from right -> left
                        var toRemove = $scope.selectedSitesModel.selected;
                        var toRemovePlain = toRemove.map(function (item) {
                            return {
                                id: item.id,
                                href: item.href,
                                value: item.value,
                                selected: false
                            };
                        });

                        // Remove from model.selectedItems
                        $scope.model.selectedItems = lodash.differenceBy($scope.model.selectedItems, toRemovePlain, 'href');

                        // Update selected list view
                        $scope.selectedSitesModel.options = lodash.differenceBy($scope.selectedSitesModel.options, toRemovePlain, 'href');
                        $scope.selectedSitesModel.selected = [];

                        // Add back to all sites options if not present already
                        var newLeftItems = toRemovePlain.filter(function(item){
                            return !$scope.allSitesModel.options.find(function(opt){ return opt.href === item.href; });
                        });
                        if (newLeftItems.length) {
                            $scope.allSitesModel.options = lodash.unionBy($scope.allSitesModel.options, newLeftItems, 'href');
                        }

                        // Re-apply filter if active
                        if ($scope.selectedSitesFilteringKeyword) {
                            applySelectedFilter($scope.selectedSitesFilteringKeyword);
                        }
                    }

                    function addAction () {
                        if (!$scope.allSitesModel.selected || !$scope.allSitesModel.selected.length) {
                            return;
                        }

                        // Move selected from left -> right
                        var toAdd = $scope.allSitesModel.selected;

                        // Create lightweight copies of selected items to avoid storing ChildScopes
                        var toAddPlain = toAdd.map(function (item) {
                            return {
                                id: item.id,
                                href: item.href,
                                value: item.value,
                                selected: !!item.selected
                            };
                        });

                        // Remove from left list using href comparison
                        $scope.allSitesModel.options = lodash.differenceBy($scope.allSitesModel.options, toAdd, 'href');
                        $scope.allSitesModel.selected = [];

                        // Add lightweight items to right list and to model.selectedItems
                        $scope.selectedSitesModel.options = lodash.unionBy($scope.selectedSitesModel.options, toAddPlain, 'href');
                        $scope.model.selectedItems = lodash.unionBy($scope.model.selectedItems || [], toAddPlain, 'href');

                        // Re-apply filter if active
                        if ($scope.selectedSitesFilteringKeyword) {
                            applySelectedFilter($scope.selectedSitesFilteringKeyword);
                        }
                    }

                    function searchAction(newVal, oldVal) {
                        if (newVal === oldVal) {
                            return;
                        }

                        canceller.resolve();
                        canceller = $q.defer();

                        $scope.model.loading = true;
                        $scope.allSitesModel.isLoading = true;

                        var params = { name: $scope.model.keyword, timeout: canceller.promise };

                        apiClient.get($scope.model.link, params).then(function (response) {
                            $scope.model.loading = false;
                            $scope.allSitesModel.isLoading = false;

                            $scope.model.response = response;

                            // Replace options with new results, excluding already selected
                            $scope.allSitesModel.options = lodash.differenceBy(
                                $scope.model.filterResponse(response),
                                $scope.model.selectedItems,
                                'href'
                            );

                            setupLoadMore(response);
                        });
                    }

                    function map(keyPath, valuePath) {
                        return function (item) {
                            if (typeof item === 'undefined'){
                                return;
                            }

                            return  {
                                id :  lodash.get(item, 'id'),
                                href :  lodash.get(item, keyPath),
                                value : lodash.get(item, valuePath)
                            };
                        }
                    }

                    function getResponseData(response) {
                        return lodash.get(response.getData(), this.responseKeyPath);
                    }

                    function filterResponse(response) {
                        return this.getResponseData(response).map(
                            this.map(this.itemHrefPath, this.itemValuePath)
                        );
                    }

                    function clearAction($event) {
                        $event.stopPropagation();

                        this.selectedItems = null;
                        $scope.model.selectedItems = null;

                        $scope.selectedSitesModel.options = [];
                        $scope.allSitesModel.options = [];
                    }

                    function expandSearchAction() {
                        var modalInstance = $uibModal.open({
                            templateUrl: '/modules/common/modals/site-search/select-site-modal.html',
                            controller: 'SiteSearchModalController',
                            controllerAs: 'vm',
                            resolve : {
                                restrictOne : false
                            }
                        });

                        modalInstance.result.then(function (data) {
                            // Remove from left list if exists
                            $scope.allSitesModel.options = lodash.differenceBy($scope.allSitesModel.options, data, 'href');
                            // Add to right list and to model
                            $scope.selectedSitesModel.options = lodash.unionBy($scope.selectedSitesModel.options, data, 'href');
                            $scope.model.selectedItems = lodash.unionBy($scope.model.selectedItems || [], data, 'href');
                        }, function () {
                        });

                        this.expandedSearch = !this.expandedSearch;

                        if (this.expandedSearch) {
                            this.keyword = null;
                            $scope.allSitesModel.selected = [];
                        }
                    }

                    // Load more support for the left list (all sites)
                    function setupLoadMore(response) {
                        $scope.allSitesModel.hasMoreOptions = false;
                        $scope.allSitesModel.loadNext = null;

                        if (!response) {
                            return;
                        }

                        var page = response.page || 1;
                        var pages = response.pages || 1;
                        var hasNextLink = !!response.getLink('next');

                        $scope.allSitesModel.hasMoreOptions = (page < pages) && hasNextLink;

                        $scope.allSitesModel.loadNext = function() {
                            var currentResponse = $scope.model.response;
                            if (!currentResponse) {
                                return $q.resolve();
                            }

                            var currentPage = currentResponse.page || 1;
                            var totalPages = currentResponse.pages || 1;
                            var currentHasNextLink = !!currentResponse.getLink('next');

                            if (currentPage >= totalPages || !currentHasNextLink) {
                                return $q.resolve();
                            }

                            var deferred = $q.defer();
                            var nextLink = currentResponse.getLink('next');

                            apiClient.get(nextLink).then(function(nextResponse){
                                // Append new options, excluding already selected
                                var newOptions = lodash.differenceBy(
                                    $scope.model.filterResponse(nextResponse),
                                    $scope.model.selectedItems,
                                    'href'
                                );

                                $scope.allSitesModel.options = $scope.allSitesModel.options.concat(newOptions);

                                // Update flags and keep the latest response
                                $scope.model.response = nextResponse;
                                var hasNext = !!nextResponse.getLink('next');
                                $scope.allSitesModel.hasMoreOptions = (nextResponse.page < nextResponse.pages) && hasNext;

                                deferred.resolve();
                            }).catch(function(err){
                                $scope.allSitesModel.hasMoreOptions = false;
                                deferred.reject(err);
                            });

                            return deferred.promise;
                        }
                    }

                    // Load more support for the right list (selected sites)
                    function setupSelectedLoadMore(response) {
                        $scope.selectedSitesModel.hasMoreOptions = false;
                        $scope.selectedSitesModel.loadNext = null;

                        if (!response) {
                            return;
                        }

                        var page = response.page || 1;
                        var pages = response.pages || 1;
                        var hasNextLink = !!response.getLink('next');

                        $scope.selectedSitesModel.hasMoreOptions = (page < pages) && hasNextLink;

                        // If there are more pages, force preload them and indicate loading state
                        if ($scope.selectedSitesModel.hasMoreOptions) {
                            $scope.selectedSitesModel.isLoading = true;
                            $scope.selectedSitesModel.forceLoadAllPages = true;
                            // Expose loading flag to parent controller via model
                            $scope.model.loadingSelected = true;
                        }

                        $scope.selectedSitesModel.loadNext = function() {
                            var currentResponse = $scope.model.selectedResponse;
                            if (!currentResponse) {
                                return $q.resolve();
                            }

                            var currentPage = currentResponse.page || 1;
                            var totalPages = currentResponse.pages || 1;
                            var currentHasNextLink = !!currentResponse.getLink('next');

                            if (currentPage >= totalPages || !currentHasNextLink) {
                                return $q.resolve();
                            }

                            var deferred = $q.defer();
                            var nextLink = currentResponse.getLink('next');

                            var params = {};
                            if ($scope.selectedSitesFilteringKeyword) {
                                params.name = $scope.selectedSitesFilteringKeyword;
                            }

                            apiClient.get(nextLink, params).then(function(nextResponse){
                                var newOptions = $scope.model.filterResponse(nextResponse);

                                // Avoid duplicates in the visible list
                                newOptions = lodash.differenceBy(newOptions, $scope.selectedSitesModel.options, 'href');

                                // Append to the visible selected list and to the master selectedItems list
                                $scope.selectedSitesModel.options = $scope.selectedSitesModel.options.concat(newOptions);
                                $scope.model.selectedItems = lodash.unionBy($scope.model.selectedItems || [], newOptions, 'href');

                                // Also ensure these newly loaded selected sites are not present in the All Sites list
                                if ($scope.allSitesModel && Array.isArray($scope.allSitesModel.options) && newOptions && newOptions.length) {
                                    $scope.allSitesModel.options = lodash.differenceBy($scope.allSitesModel.options, newOptions, 'href');
                                }

                                // Update flags and keep the latest response
                                $scope.model.selectedResponse = nextResponse;
                                var hasNext = !!nextResponse.getLink('next');
                                $scope.selectedSitesModel.hasMoreOptions = (nextResponse.page < nextResponse.pages) && hasNext;

                                // When done preloading, drop loading flags
                                if (!$scope.selectedSitesModel.hasMoreOptions && $scope.selectedSitesModel.forceLoadAllPages) {
                                    $scope.selectedSitesModel.isLoading = false;
                                    $scope.model.loadingSelected = false;
                                }

                                deferred.resolve();
                            }).catch(function(err){
                                $scope.selectedSitesModel.hasMoreOptions = false;
                                $scope.selectedSitesModel.isLoading = false;
                                $scope.model.loadingSelected = false;
                                deferred.reject(err);
                            });

                            return deferred.promise;
                        }
                    }
                }]
            };
        })
})();
